import { FormDialogConfig, Icon, IconName } from '@aibees/shared/components';
import { yup } from '@aibees/shared/utils';
import { parseCommaSeparatedValues } from '../../utils';

const MAX_VALUES = 300;

// `allowEmpty` is true when the dialog opens with an already-existing value:
// submitting an empty input is then a valid way to clear it, so the required /
// has-content checks are skipped. When there is no existing value, an empty
// input is invalid and the required error is shown.
export function createScheme(field: string, allowEmpty = false) {
  let stringSchema = yup.string();

  if (!allowEmpty) {
    stringSchema = stringSchema
      .required('At least one value is required')
      .test('has-content', 'At least one value is required', (value) => {
        if (!value?.trim()) return false;
        const parsed = parseCommaSeparatedValues(value);
        return parsed.length > 0;
      });
  }

  return yup.object().shape({
    [field]: stringSchema.test(
      'max-values',
      `Please reduce your list to ${MAX_VALUES} names or fewer to continue.`,
      (value) => {
        if (!value?.trim()) return true;
        const parsed = parseCommaSeparatedValues(value);
        return parsed.length <= MAX_VALUES;
      }
    ),
  });
}

export function createConfig(
  title: string,
  field: string,
  icon?: IconName,
  allowEmpty = false
): FormDialogConfig {
  const config: FormDialogConfig = {
    title,
    icon: <Icon name={icon || 'workspace'} size={22} color="primary" />,
    scheme: createScheme(field, allowEmpty),
    submitButtonProps: {
      children: 'Save and Search',
      size: 'small',
      variant: 'contained',
      color: 'primary',
    },
    closeButton: {
      children: 'Cancel',
      size: 'small',
      variant: 'text',
    },
  };

  return config;
}

export { MAX_VALUES };
